module.exports = __webpack_public_path__ + "media/src/images/top_covers/April_03-0b28cf766123549ab165669271aea443.png";